import React from "react";
import { motion, AnimatePresence } from "framer-motion"; // Para animaciones
import { FaCheck, FaTimes } from "react-icons/fa"; // Íconos para los botones

const ConfirmAlert = ({ message, isOpen, onClose, onConfirm }) => {
    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
                    onClick={onClose} // Cerrar al hacer clic fuera
                >
                    <motion.div
                        initial={{ y: -50, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: -50, opacity: 0 }}
                        className="bg-white rounded-lg p-6 w-full max-w-md"
                        onClick={(e) => e.stopPropagation()} // Evitar que se cierre al hacer clic dentro
                    >
                        {/* Mensaje del alert */}
                        <p className="text-lg text-gray-800 mb-6">{message}</p>

                        {/* Botones de acción */}
                        <div className="flex justify-end gap-4">
                            <button
                                onClick={() => {
                                    onConfirm(false); // Devolver false (Cancelar)
                                    onClose();
                                }}
                                className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 flex items-center gap-2"
                            >
                                <FaTimes /> Cancelar
                            </button>
                            <button
                                onClick={() => {
                                    onConfirm(true); // Devolver true (Aceptar)
                                    onClose();
                                }}
                                className="bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-600 flex items-center gap-2"
                            >
                                <FaCheck /> Aceptar
                            </button>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default ConfirmAlert;